import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Court} from "../shared/model/court";
import {AbstractControl, FormBuilder, FormControl, FormGroup, Validators} from "@angular/forms";
import {TranslateService} from "@ngx-translate/core";
import {AuthService} from "../shared/security/auth.service";
import {TenantService} from "../shared/model/tenant.service";
import {Reservation} from "../shared/model/reservation";
import {ReservationsService} from "../shared/model/reservations.service";
import {isoDate} from "../shared/util/date-util";

@Component({
  selector: 'app-reservations-add',
  templateUrl: './reservations-add.component.html',
  styleUrls: ['./reservations-add.component.css']
})
export class ReservationsAddComponent implements OnInit {

  @Input()
  tenantId: number;

  @Output()
  onAddReservationDone = new EventEmitter<boolean>();

  day: number = 1;
  index: number;
  court: number;
  startTime: string;   // local time as HH:MM
  endTime: string;   // local time as HH:MM
  name: string;
  duration: number;    // time in seconds
  type: string = 'normal';

  startTimeHours: number = 18;
  startTimeMinutes: number = 0;
  endTimeHours: number = 19;
  endTimeMinutes: number = 0;

  clubId: string;
  courts: Court[] = [];
  currentCourt: Court = null;

  public visibleAddReservation = true;
  public visibleAddReservationAnimate = false;

  myForm: FormGroup;
  isSaved: boolean = false;
  hasError: boolean = false;
  message: string = "";

  isOn: boolean = true;

  constructor(private fb: FormBuilder, private translate: TranslateService, private authService: AuthService, private tenantService: TenantService, private reservationService: ReservationsService) {
    this.myForm = fb.group({
      'startTimeHours': ['', Validators.compose([Validators.required, Validators.min(0), Validators.max(23), Validators.maxLength(2)])],
      'startTimeMinutes': ['', Validators.compose([Validators.required, Validators.min(0), Validators.max(59), Validators.maxLength(2)])],
      'endTimeHours': ['', Validators.compose([Validators.min(0), Validators.max(23), Validators.maxLength(2)])],
      'endTimeMinutes': ['', Validators.compose([Validators.min(0), Validators.max(59), Validators.maxLength(2)])],
      'type': ['', Validators.compose([])]
    });
  }

  ngOnInit() {
    this.tenantId = this.authService.getTenantIdForUser();
    this.clubId = this.authService.getClubIdForUser();
    //console.log(`tenantId: ${this.tenantId}, clubId: ${this.clubId}`);
    this.tenantService.getCourts(this.tenantId, this.clubId).then( cts => {
      this.courts = cts;
    });

    this.calculateStartTime( true );
  }

  public show(): void {
    this.visibleAddReservationAnimate = true;
    setTimeout(() => this.visibleAddReservationAnimate = true, 300);
  }

  public hide(): void {
    this.visibleAddReservationAnimate = false;
    setTimeout(() => this.visibleAddReservation = false, 300);
  }

  public save() {
    if ( !this.isOn ) {
      this.endTime = this.startTime;
    }
    const currentDate = isoDate();
    const tz = new Date().toString().match(/([-\+][0-9]+)\s/)[1]; // time zone like +0200
    const st = currentDate + 'T' + this.startTime + ':00' + tz;
    const et = currentDate + 'T' + this.endTime   + ':00' + tz;
    //console.log( `start time: ${st}, end time: ${et}` );

    const newReservation = {
      tenantId: this.tenantId,
      court: this.currentCourt.court,
      type: this.type,
      startDateTime: st,
      endDateTime: et
    };

    this.reservationService.addReservation(newReservation);
    this.formDone( true );
  }

  public formDone(done: boolean) {
    if ( done ) {
      this.onAddReservationDone.emit(false);  // hide modal add screen
    }
  }

  public selectCourt( court: Court ) {
    //console.log(`selected Court: ${JSON.stringify(court)}`);
    this.currentCourt = court;
  }

  calculateStartTime( event: any ) {
    const now = new Date();
    const nowHours = now.getHours();
    const nowMinutes = now.getMinutes();

    if ( this.startTimeHours < nowHours ) {
      this.startTimeHours = nowHours;
    }
    if ( this.startTimeHours === nowHours ) {
      if (this.startTimeMinutes < nowMinutes ) {
        this.startTimeMinutes = nowMinutes;
      }
    }

    this.startTime = this.timeToString( Number(this.startTimeHours), Number(this.startTimeMinutes) );
    this.calculateEndTime( true );
  }

  convertToFormControl(absCtrl: AbstractControl | null): FormControl {
    const ctrl = absCtrl as FormControl;
    return ctrl;
  }

  calculateEndTime( event: any ) {
      if ( this.endTimeHours < this.startTimeHours ) {
        this.endTimeHours = this.startTimeHours;
      }
      this.endTime = this.timeToString(this.endTimeHours, this.endTimeMinutes);
  }

  useSunset( useIt: boolean ) {
    if ( useIt ) {
      return "";
    } else {
      return "l.dontusesunset";
    }
  }

  timeToString( hours: number, minutes: number ): string {
    let t = "";
    let addLeadingZero1 = false;
    let addLeadingZero2 = false;

    if ( hours > 23  || minutes > 59 ) {
      return 'INVALID';
    }

    if ( hours < 10 ) {
      addLeadingZero1 = true;
    }

    if ( minutes < 10 ) {
      addLeadingZero2 = true;
    }
    t = (addLeadingZero1 ? '0' : '') + hours + ':' + (addLeadingZero2 ? '0': '') + minutes;
    return t;
  }

  toggleIsOn() {
    this.isOn = !this.isOn;
    if ( this.isOn ) {
      this.type = 'normal';
    } else {
      this.type = 'off';
    }
  }


}
